var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.072,
    height: 18,
    viewBox: "0 0 18.072 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9025736_newspaper_icon",
    "data-name": "9025736_newspaper_icon",
    transform: "translate(-0.325 -0.397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5901",
    "data-name": "Rectangle 5901",
    width: 18,
    height: 18,
    transform: "translate(0.397 0.397)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_526",
    "data-name": "Line 526",
    x2: 7,
    transform: "translate(6.397 8.397)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_527",
    "data-name": "Line 527",
    x2: 7,
    transform: "translate(6.397 10.397)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20594",
    "data-name": "Path 20594",
    d: "M32,66.7a1.189,1.189,0,0,0,1.189-1.189V56.594A.594.594,0,0,1,33.783,56H45.672a.594.594,0,0,1,.594.594v8.917A1.189,1.189,0,0,1,45.078,66.7Z",
    transform: "translate(-29.736 -51.952)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20595",
    "data-name": "Path 20595",
    d: "M17.189,96.322A1.189,1.189,0,0,1,16,95.133h0V88",
    transform: "translate(-14.925 -81.575)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeVendor);
export default __webpack_public_path__ + "static/media/change_vendor.297dc29c04ea8cecd6eb77e3bfa8b025.svg";
export { ForwardRef as ReactComponent };